module.exports = "https://www.gc-pro.gnp.com.mx/6863c483dc788a71a65a42eb76040ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sin-polizas-icon.png
// module id = 989
// module chunks = 0